// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.translateBlock__hgFAi {
  display: flex;
  align-items: center;
  column-gap: 5px;
  cursor: pointer;
  padding-right: 5px;
}
@media print {
  .translateBlock__hgFAi {
    overflow: hidden;
    height: 0;
  }
}

.translateLang__XtzZB {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-surface);
  text-transform: uppercase;
  white-space: nowrap;
}

.loader__XCGmS {
  width: 24px;
  height: 24px;
}

.disabledTranslate__OHjA8 {
  pointer-events: none;
  opacity: 0.7;
}

.translationIcon__FzHAc {
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/TranslateBtn/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAzEF;AA2EE;EAPF;IAQI,gBAAA;IACA,SAAA;EAxEF;AACF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,YAAA;AAxEF;;AA2EA;EACE,oBAAA;EACA,YAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,YAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.translateBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n  cursor: pointer;\n  padding-right: 5px;\n\n  @media print {\n    overflow: hidden;\n    height: 0;\n  }\n}\n\n.translateLang {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-surface);\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.loader {\n  width: 24px;\n  height: 24px;\n}\n\n.disabledTranslate {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.translationIcon {\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"translateBlock": `translateBlock__hgFAi`,
	"translateLang": `translateLang__XtzZB`,
	"loader": `loader__XCGmS`,
	"disabledTranslate": `disabledTranslate__OHjA8`,
	"translationIcon": `translationIcon__FzHAc`
};
module.exports = ___CSS_LOADER_EXPORT___;
